/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["not-found-page{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100vh;color:#597996}not-found-page img{display:block;margin:0 auto;max-width:90%;height:auto}not-found-page h1{font-size:4rem;font-weight:300;margin-top:50px;max-width:90%;text-align:center}not-found-page .mat-raised-button.mat-primary{color:#fff;background-color:#597996;min-width:220px;line-height:46px;max-width:90%}"];
export { styles as styles };
